var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveyDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1406,
    cy: 12,
    r: 12,
    fill: "#838383"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4942 7.64646L16.4942 5.64646C16.4478 5.60003 16.3926 5.56319 16.332 5.53806C16.2713 5.51293 16.2063 5.5 16.1406 5.5C16.075 5.5 16.0099 5.51293 15.9493 5.53806C15.8886 5.56319 15.8335 5.60003 15.787 5.64646L9.78705 11.6465C9.69329 11.7402 9.64062 11.8674 9.64063 12V14C9.64063 14.1326 9.69331 14.2598 9.78707 14.3536C9.88084 14.4473 10.008 14.5 10.1406 14.5H12.1406C12.2732 14.5 12.4004 14.4473 12.4942 14.3536L18.4942 8.35355C18.588 8.25979 18.6406 8.13261 18.6406 8.00001C18.6406 7.8674 18.588 7.74023 18.4942 7.64646V7.64646ZM16.6406 8.7929L15.3478 7.50001L16.1406 6.70712L17.4335 8.00001L16.6406 8.7929Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7412 10.5208L13.2013 15.0606C13.0623 15.2003 12.897 15.3111 12.715 15.3865C12.5329 15.462 12.3377 15.5005 12.1406 15.5H10.1406C9.74293 15.4996 9.36166 15.3414 9.08045 15.0602C8.79924 14.779 8.64107 14.3977 8.64062 14V12C8.64008 11.8029 8.67864 11.6077 8.75405 11.4257C8.82946 11.2436 8.94023 11.0783 9.07995 10.9394L13.6211 6.39825C13.5993 6.28677 13.5397 6.18622 13.4523 6.11365C13.365 6.04107 13.2552 6.00092 13.1416 6H7.14063C6.87549 6.00026 6.62129 6.1057 6.43381 6.29318C6.24633 6.48066 6.14089 6.73486 6.14062 7V17C6.14089 17.2651 6.24633 17.5193 6.43381 17.7068C6.62129 17.8943 6.87549 17.9997 7.14063 18H17.1406C17.4058 17.9997 17.66 17.8943 17.8474 17.7068C18.0349 17.5193 18.1404 17.2651 18.1406 17V11.0005C18.1397 10.8867 18.0994 10.7767 18.0266 10.6893C17.9538 10.6018 17.853 10.5423 17.7412 10.5208V10.5208Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyDisable);
export default __webpack_public_path__ + "static/media/survey_disable.0821f73d42dc853867326c2d6cceab45.svg";
export { ForwardRef as ReactComponent };